import { render } from "./CRMCustomersPage.vue?vue&type=template&id=0d2ab1ac&ts=true"
import script from "./CRMCustomersPage.vue?vue&type=script&lang=ts"
export * from "./CRMCustomersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__